var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCatalog(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.49964 4.89951C3.99669 4.89951 4.39964 4.49657 4.39964 3.99951C4.39964 3.50246 3.99669 3.09951 3.49964 3.09951C3.00258 3.09951 2.59964 3.50246 2.59964 3.99951C2.59964 4.49657 3.00258 4.89951 3.49964 4.89951Z",
    fill: "#8D969F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.23404 3.24961C5.81983 3.24961 5.48404 3.5854 5.48404 3.99961C5.48404 4.41382 5.81983 4.74961 6.23404 4.74961H12.2458C12.6601 4.74961 12.9958 4.41382 12.9958 3.99961C12.9958 3.5854 12.6601 3.24961 12.2458 3.24961H6.23404Z",
    fill: "#8D969F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.24097 12.7496L12.2498 12.7496C12.664 12.7496 12.9998 12.4138 12.9998 11.9996C12.9998 11.5854 12.664 11.2496 12.2498 11.2496L6.24097 11.2496C5.82676 11.2496 5.49097 11.5854 5.49097 11.9996C5.49097 12.4138 5.82676 12.7496 6.24097 12.7496Z",
    fill: "#8D969F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.00757 7.99961C5.00757 7.5854 5.34336 7.24961 5.75757 7.24961H13.2536C13.6678 7.24961 14.0036 7.5854 14.0036 7.99961C14.0036 8.41382 13.6678 8.74961 13.2536 8.74961H5.75757C5.34336 8.74961 5.00757 8.41382 5.00757 7.99961Z",
    fill: "#8D969F"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M2.99961 8.89961C3.49667 8.89961 3.89961 8.49667 3.89961 7.99961C3.89961 7.50255 3.49667 7.09961 2.99961 7.09961C2.50255 7.09961 2.09961 7.50255 2.09961 7.99961C2.09961 8.49667 2.50255 8.89961 2.99961 8.89961Z",
    fill: "#8D969F"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M4.39973 12C4.39973 12.497 3.99678 12.9 3.49973 12.9C3.00267 12.9 2.59973 12.497 2.59973 12C2.59973 11.5029 3.00267 11.1 3.49973 11.1C3.99678 11.1 4.39973 11.5029 4.39973 12Z",
    fill: "#8D969F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCatalog);
export default __webpack_public_path__ + "static/media/catalog.3fdbb1d7513c3f5f50b261883c54f840.svg";
export { ForwardRef as ReactComponent };